// extracted by mini-css-extract-plugin
export default {"cardForm":"formFicha_cardForm__VY1Ib","dFlexBetween":"formFicha_dFlexBetween__+vo5q","box":"formFicha_box__jhC0T","boxTitle":"formFicha_boxTitle__1GRQo"};